import { Component, Input } from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { EntityDescriptorModelUI } from '../descriptor.model';
import { EntityPropertyCharacteristicsInputComponent } from './Characteristic-Input/entity.property.characteristics.input.component';

@Component({
    selector: 'entity-property-characteristics-list',
    template: `
        <table [class.edit-mode-table]="isEditMode" class="entity-descriptor-table">
            @for (descriptor of descriptors; track descriptor) {
                <tr #formRow>
                    <td>
                        <label
                            [class.text-muted]="descriptor.isDeleted"
                            [tooltip]="descriptor.descriptor.notes"
                            container="body"
                            placement="left"
                            style="white-space: nowrap;"
                        >
                            {{ descriptor.descriptor.name }}:
                        </label>
                    </td>
                    <td>
                        <entity-property-characteristics-input
                            [descriptor]="descriptor"
                            [disabled]="descriptor.isDeleted"
                            [isEditMode]="isEditMode"
                            [saveAttempted]="saveAttempted"
                        >
                        </entity-property-characteristics-input>
                    </td>
                    <td style="padding-left: 10px;">
                        <div [class.invisible]="!isEditMode">
                            @if (!descriptor.isDeleted) {
                                <button
                                    (click)="descriptor.isDeleted = true"
                                    [disabled]="!descriptor.allowDeleteFromEntity && descriptor.rowVersion.length"
                                    class="ace-btn has-icon btn-primary btn-danger"
                                    style="margin: 0;"
                                    type="button"
                                >
                                    <i class="fa fa-trash"></i>
                                </button>
                            }
                            @if (descriptor.isDeleted) {
                                <button
                                    (click)="descriptor.isDeleted = false"
                                    class="ace-btn has-icon btn-primary"
                                    style="margin: 0;"
                                    type="button"
                                >
                                    <i class="fa fa-undo"></i>
                                </button>
                            }
                        </div>
                    </td>
                </tr>
            }
        </table>
    `,
    styles: [
        `
            .entity-descriptor-table td {
                vertical-align: middle;
            }

            .entity-descriptor-table td:first-child {
                padding-right: 15px;
            }

            .entity-descriptor-table label {
                margin: 0;
            }

            .edit-mode-table td {
                padding-bottom: 3px;
            }
        `,
    ],
    imports: [TooltipDirective, EntityPropertyCharacteristicsInputComponent],
})
export class EntityPropertyCharacteristicsListComponent {
    @Input() descriptors: EntityDescriptorModelUI[];
    @Input() isEditMode: boolean;
    @Input() saveAttempted: boolean;
}
